// Copyright (c) Move Closer 2022.

import { AnyObject } from '@movecloser/front-core'

import { IRelatedService, SearchGroup } from '../../../../contexts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const searchResultLatestResolver = async (key: string, payload: AnyObject, relatedService: IRelatedService): Promise<SearchGroup> => {
  return { group: payload.group, elements: payload.list }
}
